import "./PrivacyPolicy.scss";

import { useEffect, useState } from "react";

const PrivacyPolicy: React.FC = () => {
  const [show, setShow] = useState<boolean>(false);


  return (
    <div className="backGround-pp">
      <div className="container">
        <h1>Privacy Statement for PARK-KIT</h1>
        <p>At PARK-KIT, we are committed to protecting the privacy and security of our users. This Privacy Statement explains how we collect, use, and disclose personal information when you use our PARK-KIT, mobile application (PARK-KIT).</p>

        <h2>1. Information We Collect</h2>

        <h3>1.1 Personal Information</h3>
        <p>When you use our App, we may collect certain personal information that you provide to us voluntarily. This may include your name, email address, phone number, and any other information you choose to provide.</p>

        <h3>1.2 Usage Information</h3>
        <p>We may also collect information about how you use our App, such as the features you access, the actions you take, and the duration of your usage. This information is collected anonymously and is used to improve the functionality and user experience of our App.</p>

        <h2>2. How We Use Your Information</h2>

        <h3>2.1 Provide and Improve the App</h3>
        <p>We use the information we collect to provide and improve our App, personalize your experience, and respond to your inquiries and requests.</p>

        <h3>2.2 Communication</h3>
        <p>We may use your contact information to send you important updates, notifications, and promotional materials related to our App. You can opt-out of receiving these communications at any time.</p>

        <h3>2.3 Analytics and Research</h3>
        <p>We may use aggregated and anonymized data for analytical purposes, such as understanding user behavior, trends, and preferences. This helps us improve our App and develop new features.</p>

        <h2>3. Information Sharing and Disclosure</h2>

        <h3>3.1 Service Providers</h3>
        <p>We may share your personal information with trusted third-party service providers who assist us in operating our App, conducting business activities, and providing services to you. These service providers are obligated to protect your information and are prohibited from using it for any other purpose.</p>

        <h3>3.2 Legal Requirements</h3>
        <p>We may disclose your personal information if required to do so by law or in response to a valid legal request, such as a court order or government investigation.</p>

        <h3>3.3 Business Transfers</h3>
        <p>In the event of a merger, acquisition, or sale of all or a portion of our assets, your personal information may be transferred to the acquiring entity. We will notify you before your information is transferred and becomes subject to a different privacy policy.</p>

        <h2>4. Data Security</h2>
        <p>We take reasonable measures to protect the security of your personal information and prevent unauthorized access, disclosure, or alteration. However, please note that no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>

        <h2>5. Children's Privacy</h2>
        <p>Our App is not intended for use by children under the age of 13. We do not knowingly collect personal information from children. If you believe that we may have collected personal information from a child without parental consent, please contact us, and we will promptly delete the information.</p>

        <h2>6. Your Choices and Rights</h2>
        <p>You have the right to access, update, and delete your personal information. You can also choose to opt-out of receiving promotional communications from us. Please contact us if you wish to exercise any of these rights or have any questions about your privacy.</p>

        <h2>7. Changes to this Privacy Statement</h2>
        <p>We may update this Privacy Statement from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes by posting the updated Privacy Statement on our App. Your continued use of the App after the effective date of the updated Privacy Statement constitutes your acceptance of the changes.</p>

        <h2>8. Contact Us</h2>
        <p>If you have any questions, concerns, or requests regarding this Privacy Statement or our privacy practices, please contact us at <a href="mailto:info@park-kit.net">info@park-kit.net</a>.</p>

        <p><strong>Effective Date:</strong> JULY 2024</p>
      </div>
    </div >
  );
};

export default PrivacyPolicy;
